module.exports = __webpack_public_path__ + "img/xjzzy.7a06f198.png";